import { gql } from '@common/hooks';
import { OFFER_INFO_DETAILS_FRAGMENT } from '@applicant-flow/graphql/fragments';
import { EXTENSION_OFFER_DETAILS_FRAGMENT } from '@working-experience/graphql';

const CreateResponseOfferAcceptance = gql`
  mutation CreateResponseOfferAcceptance(
    $offerChangeRequestId: ID!
    $input: CreateResponseOfferAcceptanceInput!
  ) {
    createResponseOfferAcceptance(
      offerChangeRequestId: $offerChangeRequestId
      input: $input
    ) {
      offerChangeResponse {
        id
        note
        updatedAt
        changeRequestable {
          ... on Offer {
            id
            ...OfferDetailsInfo
          }
          ... on ExtensionOffer {
            id
            ...ExtensionOfferDetailsFragment
          }
        }
      }
      errors {
        attribute
        humanAttribute
        errors
        fullErrors
      }
    }
  }
  ${OFFER_INFO_DETAILS_FRAGMENT}
  ${EXTENSION_OFFER_DETAILS_FRAGMENT}
`;

const CreateResponseExtensionOfferAcceptance = gql`
  mutation CreateResponseExtensionOfferAcceptance(
    $offerChangeRequestId: ID!
    $input: CreateResponseExtensionOfferAcceptanceInput!
  ) {
    createResponseExtensionOfferAcceptance(
      offerChangeRequestId: $offerChangeRequestId
      input: $input
    ) {
      offerChangeResponse {
        id
        note
        updatedAt
        changeRequestable {
          ... on Offer {
            id
            ...OfferDetailsInfo
          }
          ... on ExtensionOffer {
            id
            ...ExtensionOfferDetailsFragment
          }
        }
      }
      errors {
        attribute
        humanAttribute
        errors
        fullErrors
      }
    }
  }
  ${OFFER_INFO_DETAILS_FRAGMENT}
  ${EXTENSION_OFFER_DETAILS_FRAGMENT}
`;

export {
  CreateResponseOfferAcceptance,
  CreateResponseExtensionOfferAcceptance,
};
